<template>
  <div class="map" :class="{'poi': $props.page === 'poi'}" id="map"></div>
</template>

<script>
export default {
    data: function () {
      return {
          customMarkers: [],
          showMap: false,
          bounds: new mapboxgl.LngLatBounds(),
          mapCore: null
      }
  },
  watch: {
      "$props.props": function() {
          this.showMap = true;
      }
  },
  props: {
    map: {
        type: Object,
        required: true
    },
    page: String,
    nearby: Array,
    props: Array
  },
  methods: {
      createMap: function() {
          let app = this;
          let map = app.$el;

          mapboxgl.accessToken = "pk.eyJ1Ijoic25hcHRyaXBrcmlzIiwiYSI6ImNqa2RvejJucDB5bm4zcnM1ZDlyOHVqZnQifQ.VZTOARdDaid-d4yf2Q182g";

          app.mapCore = new mapboxgl.Map({
              container: map,
              style: 'mapbox://styles/mapbox/streets-v11',
              center: app.$props.map.coords,
              zoom: app.$props.map.zoom
          });
          app.mapCore.addControl(new mapboxgl.NavigationControl(), 'top-left');
          app.mapCore.addControl(new mapboxgl.ScaleControl({ unit: "imperial" }));

          st.remove(document.querySelector(".mapboxgl-ctrl-logo").parentNode);

          app.addMarker(app.$props.map.coords, "pin center");

          if (app.customMarkers) {
              app.addCustomMarkers();
          }
      },
      addMarker: function(coords, classN, tag) {
          const el = document.createElement('div'),
                span = document.createElement('span'),
                app = this;

          el.className = classN;

          if (typeof tag !== "undefined")  {
              span.innerHTML = tag;
              el.appendChild(span);
          }
          return new mapboxgl.Marker(el).setLngLat(coords).addTo(app.mapCore);
      },
      addCustomMarkers: function() {
          let app = this,
              icon, markers = this.$props.props.concat(this.$props.nearby);

          for (let i = 0; i < markers.length; i++) {
              let marker = markers[i];
              let coords = [marker[1], marker[0]], icon, tag = marker[2];

              icon = typeof marker[3] !== "undefined" ? "pin prop" : "pin icon";
              app.addMarker(coords, icon, tag);
              app.bounds.extend(coords);
          }
          app.mapCore.fitBounds(app.bounds);
      },
      handleScroll: function() {
        let app = this,
            scroll = window.pageYOffset,
            isShowing, map = app.$el.getBoundingClientRect().top;
        isShowing = app.inViewport(app.$el);

        if (scroll > map && isShowing && app.showMap) {
            app.createMap();
            window.removeEventListener('scroll', this.handleScroll);
        }
      },
      inViewport: function(el) {
          let box = el.getBoundingClientRect();
          return (
              box.top >= 0 &&
              box.left >= 0 &&
              box.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
              box.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
      }
  },
  mounted: function() {
     window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function() {
      window.removeEventListener('scroll', this.handleScroll);
  }
}

</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';
.map {
  background: #424F98;
  top: .0625rem;
  height: 26.563rem;
  width: 100%;
  position: relative;
}

.poi {
  height: 25rem;
}

@media #{$desktop} {
  .poi {
    height: 40rem;
  }
}
</style>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

// Our custom styles

.pin {
  span {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
    z-index: 2;
    width: auto;
    background: $col_white;
    font-size: .7rem;
    min-height: 2rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: .625rem;
    border-radius: .313rem;
    box-shadow: 0 .0625rem .125rem 0 $col_midgrey;
    border: 0.0625rem solid $col_medgrey;

    &:after,
    &:before {
      content: "";
      border-style: solid;
      height: 0;
      width: 0;
      border-width: .625rem .313rem 0;
      position: absolute;
      left: 50%;
      margin-left: -.313rem;
    }

    &:after {
      bottom: -.625rem;
      border-color: $col_white transparent transparent;
      z-index: 2;
    }

    &:before {
      bottom: -.688rem;
      border-color: $col_midgrey transparent transparent;
      z-index: 1;
    }
  }

  &:hover span {
    opacity: 1;
  }

  &.prop {
    background: url("~search/pins.svg") no-repeat 0 0;
    cursor: pointer;
    z-index: 1;
    border-radius: 100%;
    width: 1.375rem;
    height: 1.375rem;
    background-size: 100%;
  }

  &.icon {
    background: url("~leaflet/marker-icon-orange.png") no-repeat 0 0;
    width: 1.563rem;
    height: 2.563rem;

    @media
    (-webkit-min-device-pixel-ratio: 2),
    (min-resolution: 192dpi) {
      background: url("~leaflet/marker-icon-2x-orange.png") no-repeat 0 0;
      background-size: 100%;
    }
  }

  &.center {
    background: url("~leaflet/marker-icon-red") no-repeat 0 0;
    width: 1.563rem;
    height: 2.563rem;
    z-index: 9;

    @media
    (-webkit-min-device-pixel-ratio: 2),
    (min-resolution: 192dpi) {
      background: url("~leaflet/marker-icon-2x-red") no-repeat 0 0;
      background-size: 100%;
    }
  }
}

</style>